import { useEffect, useState } from "react";

const API = process.env.REACT_APP_NAV_API;

const styles = {
  wrapper: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    background: "#F7F9FC",
    minHeight: "100vh",
    padding: "32px",
  },
  card: {
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(38,66,139,0.08)",
    padding: "36px 40px",
    maxWidth: "920px",
    margin: "0 auto",
    border: "1px solid #E8EDF5",
  },
  headingRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "28px",
    paddingBottom: "20px",
    borderBottom: "1px solid #EEF1F7",
  },
  headingIcon: {
    width: "36px",
    height: "36px",
    background: "linear-gradient(135deg, #3B5BDB 0%, #4C6EF5 100%)",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heading: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "700",
    color: "#1A2340",
    letterSpacing: "-0.3px",
  },
  subheading: {
    margin: 0,
    fontSize: "13px",
    color: "#8A94A8",
    fontWeight: "400",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "18px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "18px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#5A6480",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  select: {
    padding: "10px 14px",
    border: "1.5px solid #DDE3EF",
    borderRadius: "10px",
    fontSize: "14px",
    color: "#1A2340",
    background: "#FAFBFD",
    outline: "none",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%238A94A8' stroke-width='1.8' stroke-linecap='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 14px center",
    cursor: "pointer",
    transition: "border-color 0.15s, box-shadow 0.15s",
  },
  input: {
    padding: "10px 14px",
    border: "1.5px solid #DDE3EF",
    borderRadius: "10px",
    fontSize: "14px",
    color: "#8A94A8",
    background: "#F4F6FA",
    outline: "none",
    cursor: "not-allowed",
  },
  checkboxSection: {
    background: "#F7F9FC",
    border: "1.5px solid #E8EDF5",
    borderRadius: "12px",
    padding: "14px 16px",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize: "13px",
    color: "#2D3A5E",
    fontWeight: "500",
    cursor: "pointer",
    padding: "5px 10px",
    borderRadius: "7px",
    transition: "background 0.12s",
    userSelect: "none",
  },
  checkbox: {
    width: "15px",
    height: "15px",
    accentColor: "#3B5BDB",
    cursor: "pointer",
  },
  btnRow: {
    marginTop: "8px",
  },
  btn: {
    padding: "11px 28px",
    background: "linear-gradient(135deg, #3B5BDB 0%, #4C6EF5 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    letterSpacing: "0.2px",
    boxShadow: "0 2px 8px rgba(59,91,219,0.3)",
    transition: "opacity 0.15s, transform 0.1s",
  },
  divider: {
    height: "1px",
    background: "#EEF1F7",
    margin: "20px 0",
  },
  // Modal
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(15,25,55,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(3px)",
    zIndex: 1000,
  },
  modalBox: {
    background: "#ffffff",
    borderRadius: "18px",
    padding: "32px 36px",
    width: "360px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
    border: "1px solid #E8EDF5",
  },
  modalTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#1A2340",
    margin: "0 0 20px 0",
  },
  modalRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "10px 0",
    borderBottom: "1px solid #F0F3FA",
    fontSize: "14px",
  },
  modalKey: {
    color: "#8A94A8",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    minWidth: "70px",
  },
  modalVal: {
    color: "#1A2340",
    fontWeight: "600",
    textAlign: "right",
    fontSize: "13px",
  },
  modalBtns: {
    display: "flex",
    gap: "10px",
    marginTop: "22px",
  },
  confirmBtn: {
    flex: 1,
    padding: "11px",
    background: "linear-gradient(135deg, #3B5BDB 0%, #4C6EF5 100%)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(59,91,219,0.3)",
  },
  cancelBtn: {
    flex: 1,
    padding: "11px",
    background: "#F0F3FA",
    color: "#5A6480",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default function AccessForm({ editData, clearEdit }) {
  const [departments, setDepartments] = useState([]);
  const [emails, setEmails] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [misProcesses, setMisProcesses] = useState([]);
  const [emProcesses, setEmProcesses] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

const [form, setForm] = useState({
  department: "",
  email: "",
  name: "",
  roles: [],
  process_access: [],
  mis_access: [],
  em_access: [],
});
useEffect(() => {
  fetch(`${API}/admin/departments`, {
    credentials: "include"   // 👈 FIX
  })
    .then(r => r.json())
    .then(d => setDepartments(d.items || []));
}, []);

  useEffect(() => {
    fetch(`${API}/admin/processes`, {
  credentials: "include"
})
      .then(r => r.json())
      .then(d => setProcesses(d.items || []));
  }, []);

  useEffect(() => {
  fetch(`${API}/admin/mis-processes`, {
  credentials: "include"
})
    .then(r => r.json())
    .then(d => setMisProcesses(d.items || []));
}, []);

useEffect(() => {
  fetch(`${API}/admin/em-processes`, {
    credentials: "include"
  })
    .then(r => r.json())
    .then(d => setEmProcesses(d.items || []));
}, []);
console.log(emProcesses);

  useEffect(() => {
    if (!form.department) return;
    setForm(prev => ({ ...prev, email: "", name: "" }));
    fetch(`${API}/admin/employees?dept=${form.department}`, {
  credentials: "include"
})
      .then(r => r.json())
      .then(d => setEmails(d.items || []));
  }, [form.department]);

  useEffect(() => {
    if (editData) setForm(editData);
  }, [editData]);

  function submitFinal() {
    fetch(`${API}/admin/access`, {
      method: editData ? "PUT" : "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // 👈 ADD
      body: JSON.stringify(form),
    }).then(() => {
      setShowConfirm(false);
      alert("Saved");
      setForm({
  department: "",
  email: "",
  name: "",
  roles: [],
  process_access: [],
  mis_access: [],
  em_access: [],
});
      clearEdit();
    });
  }

useEffect(() => {
  fetch(`${API}/nav/roles`, {
    credentials: "include"
  })
    .then(r => r.json())
    .then(d => setRoleOptions(d.items || []))
    .catch(err => console.error("Failed to load roles", err));
}, []);

  // const roleOptions = ["USER", "PC", "MIS", "HOD", "SALES", "ADMIN"];
  // const roleOptions = ["USER", "PC", "MIS", "HOD", "SALES", "EM", "ADMIN"];

  return (
    <div style={styles.card}>
      {/* Header */}
      <div style={styles.headingRow}>
        <div style={styles.headingIcon}>
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" fill="#fff"/>
          </svg>
        </div>
        <div>
          <p style={styles.heading}>{editData ? "Edit Access" : "Grant Access"}</p>
          <p style={styles.subheading}>{editData ? "Update user permissions" : "Assign roles & process access to a user"}</p>
        </div>
      </div>

      {/* Department + Email row */}
      <div style={styles.grid}>
        <div style={styles.field}>
          <label style={styles.label}>Department</label>
          <select
            style={styles.select}
            value={form.department}
            onChange={e => setForm({ ...form, department: e.target.value })}
          >
            <option value="">Select dept</option>
            {departments.map(d => <option key={d}>{d}</option>)}
          </select>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Email</label>
          <select
            style={styles.select}
            value={form.email}
            onChange={e => {
              const emp = emails.find(x => x.email === e.target.value);
              if (!emp || emp.isAdded) return;
              setForm({ ...form, email: emp.email, name: emp.name });
            }}
          >
            <option value="">Select email</option>
            {emails.map(e => (
                <option
                  key={e.email}
                  value={e.email}
                  disabled={e.isAdded && !editData}
                >
                  {e.email} ({e.name}) {e.isAdded ? " - Already Added" : ""}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Name */}
      <div style={styles.field}>
        <label style={styles.label}>Full Name</label>
        <input style={styles.input} value={form.name} readOnly placeholder="Auto-filled on email selection" />
      </div>

      <div style={styles.divider} />

      {/* Roles */}
      <div style={styles.field}>
        <label style={styles.label}>Roles</label>
        <div style={styles.checkboxSection}>
          {roleOptions.map(r => (
            <label
              key={r}
              style={{
                ...styles.checkboxLabel,
                background: form.roles.includes(r) ? "#EEF2FF" : "transparent",
                color: form.roles.includes(r) ? "#3B5BDB" : "#2D3A5E",
              }}
            >
              <input
                type="checkbox"
                style={styles.checkbox}
                checked={form.roles.includes(r)}
                onChange={() => {
                  setForm(prev => ({
                    ...prev,
                    roles: prev.roles.includes(r)
                      ? prev.roles.filter(x => x !== r)
                      : [...prev.roles, r],
                  }));
                }}
              />
              {r}
            </label>
          ))}
        </div>
      </div>

      {/* Process Access */}
      <div style={styles.field}>
        <label style={styles.label}>Process Access</label>
        <div style={styles.checkboxSection}>
          {processes.map(p => (
            <label
              key={p}
              style={{
                ...styles.checkboxLabel,
                background: form.process_access.includes(p) ? "#EEF2FF" : "transparent",
                color: form.process_access.includes(p) ? "#3B5BDB" : "#2D3A5E",
              }}
            >
              <input
                type="checkbox"
                style={styles.checkbox}
                checked={form.process_access.includes(p)}
                onChange={() => {
                  setForm(prev => ({
                    ...prev,
                    process_access: prev.process_access.includes(p)
                      ? prev.process_access.filter(x => x !== p)
                      : [...prev.process_access, p],
                  }));
                }}
              />
              {p}
            </label>
          ))}
        </div>
      </div>


      {/* MIS Access */}
      {/* MIS Access (only if MIS role selected) */}
{form.roles.includes("MIS") && (
  <div style={styles.field}>
    <label style={styles.label}>MIS Access</label>
    <div style={styles.checkboxSection}>
      {misProcesses.map(p => (
        <label
          key={p}
          style={{
            ...styles.checkboxLabel,
            background: form.mis_access.includes(p) ? "#EEF2FF" : "transparent",
            color: form.mis_access.includes(p) ? "#3B5BDB" : "#2D3A5E",
          }}
        >
          <input
            type="checkbox"
            style={styles.checkbox}
            checked={form.mis_access.includes(p)}
            onChange={() => {
              setForm(prev => ({
                ...prev,
                mis_access: prev.mis_access.includes(p)
                  ? prev.mis_access.filter(x => x !== p)
                  : [...prev.mis_access, p],
              }));
            }}
          />
          {p}
        </label>
      ))}
    </div>
  </div>
)}

{form.roles.includes("EM") && (
  <div style={styles.field}>
    <label style={styles.label}>EM Access</label>

    <div style={styles.checkboxSection}>
      {emProcesses.map(p => (
        <label
          key={p}
          style={{
            ...styles.checkboxLabel,
            background: form.em_access.includes(p)
              ? "#EEF2FF"
              : "transparent",
            color: form.em_access.includes(p)
              ? "#3B5BDB"
              : "#2D3A5E",
          }}
        >
          <input
            type="checkbox"
            style={styles.checkbox}
            checked={form.em_access.includes(p)}
            onChange={() => {
              setForm(prev => ({
                ...prev,
                em_access: prev.em_access.includes(p)
                  ? prev.em_access.filter(x => x !== p)
                  : [...prev.em_access, p],
              }));
            }}
          />
          {p}
        </label>
      ))}
    </div>
  </div>
)}

      <div style={styles.btnRow}>
        <button style={styles.btn} onClick={() => setShowConfirm(true)}>
          {editData ? "Update Access" : "Grant Access"}
        </button>
      </div>

      {/* Confirm Modal */}
      {showConfirm && (
        <div style={styles.overlay}>
          <div style={styles.modalBox}>
            <p style={styles.modalTitle}>Confirm Submission</p>

            <div style={styles.modalRow}>
              <span style={styles.modalKey}>Email</span>
              <span style={styles.modalVal}>{form.email}</span>
            </div>
            <div style={styles.modalRow}>
              <span style={styles.modalKey}>Name</span>
              <span style={styles.modalVal}>{form.name}</span>
            </div>
            <div style={styles.modalRow}>
              <span style={styles.modalKey}>Roles</span>
              <span style={styles.modalVal}>{form.roles.join(", ") || "—"}</span>
            </div>
            {/* ✅ ADD MIS HERE */}
{form.roles.includes("MIS") && (
  <div style={styles.modalRow}>
    <span style={styles.modalKey}>MIS</span>
    <span style={styles.modalVal}>
      {form.mis_access.join(", ") || "—"}
    </span>
  </div>
)}
            <div style={{ ...styles.modalRow, borderBottom: "none" }}>
              <span style={styles.modalKey}>Process</span>
              <span style={styles.modalVal}>{form.process_access.join(", ") || "—"}</span>
            </div>

            <div style={styles.modalBtns}>
              <button style={styles.confirmBtn} onClick={submitFinal}>Confirm</button>
              <button style={styles.cancelBtn} onClick={() => setShowConfirm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}